import { Box, Button, Card, CardContent, Stack } from '@mui/material'
import React, { useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CategoryHeader from '../../Components/Headers/CategoryHeader'

const BiDocumentPage = () => {

    const [downloadClicked, setDownloadClicked] = useState(false)
    const [sendLinkCustomer, setSendLinkCustomer] = useState(false)

    const { state } = useLocation();
    const {bi_link,doc} = state
    console.log('ss',bi_link,state)
    const navigate = useNavigate()

    const { id } = useParams();

    console.log(id)


    const productIdArray = id.split('*')
    const payment_config_id = productIdArray[0]
    const transId = productIdArray[1]
    const validateFormid = productIdArray[2]
    //const bi_Link = productIdArray[3]

    const handlerNext = () => {
        navigate(`/life-insurance/paypremium/${payment_config_id}*${transId}*${validateFormid}`)
    }

    const backButtonHandler = () => {
        navigate(-1);
    }

    const clickedDownLoad =()=>{
        setDownloadClicked(true)
    }
    const sendSMS =()=>{
        setSendLinkCustomer(true)
    }

    const downloadPDF=(base64,fileId) =>{
        const linkSource = `data:application/pdf;base64,${base64}`;
        const downloadLink = document.createElement("a");
        const fileName = `${fileId}`;
    
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const downLoadPolicy =()=>{
        console.log('clicked',doc.FileName)

        downloadPDF(doc.Base64file,doc.FileName)
        setDownloadClicked(true)
    }

    return (
        <Box>
            <CategoryHeader title="Life Insurance" />
            <Box sx={{ padding: '16px', marginTop: 12 }}>
                <Card>
                    <CardContent>
                        <div className='mt-3 mb-3'>
                           {/*  <button
                                className={sendLinkCustomer?"clickActive mb-4":"payment-btn mb-4"}
                                onClick={sendSMS}
                            >
                                Send BI Link to the Customer
                            </button> */}
                          {/*   <a href={`http://${bi_link}`} 
                            target="_blank" rel="document"  
                            onClick={clickedDownLoad}
                            > */}
                                <button className={downloadClicked ? "clickActive":"payment-btn"}
                                    disabled={downloadClicked}
                                    onClick={downLoadPolicy}
                                >Download BI Document</button>

                           {/*  </a> */}
                        </div>
                    </CardContent>

                </Card>
            </Box>
            <div className="btn-sec position-fixed bottom-0 mt-3 ">
               
                <button className='Goback_btn' 
                    onClick={backButtonHandler}
                >
                    Back
                </button>
                <button className='submitBtn' 
                    onClick={handlerNext}
                >
                    Next
                </button>

            </div>
        </Box>
    )
}

export default BiDocumentPage